<template>
  <div class="login-page">
    <el-card class="login-card">
      <div class="login-brand">用户中心</div><p class="login-subtitle">统一管理店铺、账号与角色权限</p>
      <el-form ref="form" :model="form" :rules="rules" :disabled="loading" @submit.native.prevent="submit">
        <el-form-item prop="username"><el-input v-model.trim="form.username" prefix-icon="el-icon-user" placeholder="用户名" aria-label="用户名" autocomplete="username" maxlength="80" /></el-form-item>
        <el-form-item prop="password"><el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" placeholder="密码" aria-label="密码" show-password autocomplete="current-password" /></el-form-item>
        <el-form-item><el-button type="primary" class="login-btn" :loading="loading" native-type="submit">登录</el-button></el-form-item>
        <el-button plain class="demo-btn" @click="demo">进入演示模式（只读）</el-button>
      </el-form>
      <p v-if="error" class="error" role="alert">{{ error }}</p>
    </el-card>
  </div>
</template>

<script>
import { errorMessage } from '../utils/management.cjs';
export default {
  data: () => ({ form: { username: '', password: '' }, loading: false, error: '', rules: { username: [{ required: true, message: '请输入用户名', trigger: 'blur' }], password: [{ required: true, message: '请输入密码', trigger: 'blur' }] } }),
  methods: {
    async submit() {
      if (this.loading || !await this.$refs.form.validate().catch(() => false)) return;
      this.loading = true; this.error = '';
      try { await this.$store.dispatch('login', this.form); this.$router.replace('/dashboard'); }
      catch (error) { this.error = errorMessage(error, '登录失败，请检查网络或账号'); }
      finally { this.loading = false; }
    },
    async demo() { if (this.loading) return; await this.$store.dispatch('login', { demo: true }); this.$router.replace('/dashboard'); }
  }
};
</script>
